"use client";

import { useParams } from "next/navigation";
import { VendorDetailView } from "@/components/VendorDetailView";

export default function VendorPage() {
  const params = useParams<{ id: string }>();
  return <VendorDetailView key={params.id} vendorId={Number(params.id)} />;
}
